const SET_SEARCH_QUERY = 'search/SET_SEARCH_QUERY';
const SHOW_SEARCH = 'search/SHOW_SEARCH';

export const initialState = {
  hero: false
};

export default function search(state = initialState, action) {
  if (action.type === SET_SEARCH_QUERY) {
    return {
      ...state,
      ...action.payload
    };
  }
  if (action.type === SHOW_SEARCH) {
    return {
      ...state,
      hero: action.payload
    };
  }
  return state;
}

export function setSearchQuery(query) {
  const { q, rent, rooms, size } = query;

  return {
    type: SET_SEARCH_QUERY,
    payload: { q, rent, rooms, size }
  };
}

export function showSearch(bool) {
  return {
    type: SHOW_SEARCH,
    payload: bool
  };
}
